import { React, useEffect, useState } from 'react';
import moment from 'moment';
import './securities-updates.scss';

import { securitiesUpdates } from '../../../../api/api';
import { fromOADate, groupBy } from '../../../../assets/scripts/helpers';

// Assets
// ---------------------
import HeaderImage from '../../../../assets/images/securitities-updates-img.jpg';

// Components
// ---------------------
import { PageHeader } from '../../../../components/page-header/page-header';
import { Accordion } from '../../../../components/accordion/accordion';
import { Table } from '../../../../components/table/table';
import { RSSLink } from '../../../../components/rss-link/rss-link';
import { LoadingSpinner } from '../../../../components/loading-spinner/loading-spinner';

export const SecuritiesUpdates = ({ ...props }) => {
  const headerTitle = 'Securities Updates';
  const headerText = `The following table details the latest instrument changes. The full 'List of Tradable Securities' is available on the Participant Information page`;
  const headerImg = (
    <img src={HeaderImage} alt="Two people walking across a building bridge." />
  );

  const params = new URLSearchParams(window.location.search.substring(1));
  const isArchived = params.get('archive');
  const isArchivedParameter = isArchived === '1' ? '&archive=1' : '';
  const rssPath = `/sigmaxmtf/downloadDocuments?downloadType=rss&Id=SecuritiesUpdates${isArchivedParameter}`;

  const tableHeaders = [
    { key: 'changeType', value: 'Change Type' },
    { key: 'instrumentName', value: 'Instrument Name' },
    { key: 'isinCode', value: 'ISIN Code' },
    { key: 'tradingCode', value: 'Trading Code' },
    { key: 'classCode', value: 'Class Code' },
    { key: 'securityExchange', value: 'Security Exchange' },
    { key: 'umtfCode', value: 'UMTF Code' },
    { key: 'venuMic', value: 'Venue Mic' }, // API key typo, but this'll work fine
    { key: 'currency', value: 'Currency' },
    { key: 'effectiveDate', value: 'Effective Date' },
  ];

  // Get Data
  // -----
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    securitiesUpdates(
      {},
      {
        StartDate: moment().subtract(10, 'years').format('YYYY/MM/DD'),
        EndDate: moment().add(30, 'days').format('YYYY/MM/DD'),
      }
    ).then((response) => {
      let result = response.data.securitiesUpdates;

      // Unique Formatting
      result.forEach((r) => {
        r.effectiveDate = moment(fromOADate(r.effectiveDate)).format(
          'D/M/YYYY'
        );
      });

      let orderedResults = groupBy(result, (d) => d.year);
      orderedResults.forEach((year) => {
        year.data = groupBy(year.data, (m) => m.month);
      });

      // Find & Expand Most Recent Year and Month
      // -----
      let currentYear = orderedResults.reduce(function (prev, current) {
        return prev.key > current.key ? prev : current;
      });
      let currentMonth = currentYear.data.reduce(function (prev, current) {
        return prev.key > current.key ? prev : current;
      });
      // Get Current Variant
      // let currentYear = orderedResults.find((y) => {
      //   return y.key === moment().get('year');
      // });
      // let currentMonth = currentYear.data.find((m) => {
      //   return m.key === moment().get('month') + 1;
      // });

      if (currentYear) {
        currentYear.expanded = true;
      }
      if (currentMonth) {
        currentMonth.expanded = true;
      }
      // -----

      setData(orderedResults);
      setIsLoading(false);
    });
  }, []);

  return (
    <div className={`securities-updates-subpage`}>
      <PageHeader title={headerTitle} text={headerText} img={headerImg} />
      <div className="content-wrapper">
        <RSSLink path={rssPath} aria={`View RSS for ${headerTitle}`} />
        <LoadingSpinner status={isLoading} name={'Securities Updates'} />
        <div className="content" hidden={isLoading}>
          {data.map((year, y) => {
            return (
              <Accordion
                key={`${y}-${year.key}`}
                text={year.key}
                initialExpand={year.expanded ? true : false}
                maxHeight={10000}
              >
                {year.data.map((month, m) => {
                  return (
                    <Accordion
                      key={`${y}-${year.key}-${m}-${month.key}`}
                      text={moment()
                        .month(month.key - 1)
                        .format('MMMM')}
                      initialExpand={month.expanded ? true : false}
                    >
                      <div className="display-data">
                        <Table
                          headers={tableHeaders}
                          data={month.data}
                          aria={`Securities Updates ${year.key}, ${moment()
                            .month(month.key - 1)
                            .format('MMMM')}`}
                        />
                      </div>
                    </Accordion>
                  );
                })}
              </Accordion>
            );
          })}
          <div className="content-footer" />
        </div>
      </div>
    </div>
  );
};
